export interface SpaceHolderProps {
  isVertical?: boolean;
  value: string;
  id?: string;
}

/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback triangle alert
 */
export default function SpaceHolder({
  isVertical = true,
  value,
  id = "",
}: SpaceHolderProps) {
  return (
    <div
      style={{
        width: isVertical ? "0px" : value,
        height: isVertical ? value : "0px",
      }}
      id={id}
    ></div>
  );
}
